import Head from "next/head";
import React from "react";

import TabsMenu from "components/global/TabsMenu/TabsMenu";
import Legal from "components/legal/Legal/Legal";
import CONSTANTS from "config/constants";

const { TITLE } = CONSTANTS;

interface Props {}

const LegalPage = (props: Props) => {
  return (
    <>
      <Head>
        <title>Términos legales | {TITLE}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <Legal />
      </TabsMenu>
    </>
  );
};

export default LegalPage;
